module.exports = __webpack_public_path__ + "dingbeauty-build/img/pet_default.05ef52ff.svg";